import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/userService/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-detailcompany',
  templateUrl: './detailcompany.component.html',
  styleUrls: ['./detailcompany.component.css']
})

export class DetailcompanyComponent implements OnInit {
  registerForm: FormGroup;
  companydata: any;
  url: string;
  comdata: any;
  downloadurl: string;
  modalRef: any;
  filesname: any;
  file: any;
  CompanyId: any;
  permission: any;
  userRId: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private toastrService: ToastrService,
  ) { }

  id: any
  ngOnInit(): void {
    let decid = this.route.snapshot.params['id'];
    decid = decid.toString().replace('Ar1t', '=').replace('FGH', '/').replace('THD', '+');
    this.id = this.UserService.decryptData(decid);
    this.url = environment.app_path;
    this.downloadurl = environment.app_downpath;
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Company_View != 1 && this.userRId != 1) {
      this.toastrService.error('You do not have permission');
      this.router.navigate(['/profile']);
    }
    this.registerForm = this.formBuilder.group({
      CompanyName: [''],
      ParentCompany: [''],
      employer_type: [''],
      CompanyTypeId: [''],
      CompanyProfileId: [''],
      BusinessStreamId: [''],
      AccountManager: [''],
      CategoryId: [''],
      Mobile: [''],
      Landline: [''],
      CountryId: [''],
      PaymentHistoryId: [''],
      FinancialStatusId: [''],
      SupplierDeliveryHistoryId: [''],
      KeyAccounts: [''],
      ClientTime: [''],
      StateId: [''],
      CityId: [''],
      MapLocation: [''],
      Fax: [''],
      Email: [''],
      Website: [''],
      AddressLine1: [''],
      AddressLine2: [''],
      AddressLine3: [''],
      PostalCode: [''],
      Remarks: [''],
    })

    let data = {
      "CompanyId": this.id,
      "Mode": "View"
    }
    this.spinner.show();
    this.UserService.GetEditCompanyDetail(data).subscribe(res => {
      this.spinner.hide();
      this.companydata = res['UploadDocument'];
      this.comdata = res['Data'];
      this.registerForm.patchValue({
        CompanyName: res['Data']['CompanyName'],
        ParentCompany: res['Data']['parentcompany'],
        CompanyTypeId: res['Data']['CompanyType'],
        CompanyProfileId: res['Data']['CompanyProfileName'],
        BusinessStreamId: res['Data']['BusinessStream'],
        AccountManager: res['Data']['UserName'],
        CategoryId: res['Data']['CategoryName'],
        Mobile: res['Data']['Mobile'],
        Landline: res['Data']['Landline'],
        CountryId: res['Data']['CountryName'],
        PaymentHistoryId: res['Data']['PaymentHistoryName'],
        FinancialStatusId: res['Data']['FinancialStatusName'],
        SupplierDeliveryHistoryId: res['Data']['SupplierDeliveryHistory'],
        KeyAccounts: res['Data']['KeyAccounts'],
        ClientTime: res['Data']['ClientTime'],
        StateId: res['Data']['StateName'],
        CityId: res['Data']['CityName'],
        MapLocation: res['Data']['MapLocation'],
        Fax: res['Data']['Fax'],
        Email: res['Data']['Email'],
        Website: res['Data']['Website'],
        AddressLine1: res['Data']['AddressLine1'],
        AddressLine2: res['Data']['AddressLine2'],
        AddressLine3: res['Data']['AddressLine3'],
        PostalCode: res['Data']['PostalCode'],
        Remarks: res['Data']['Remarks']
      })
    })

  }

  companyDetailArray: any = []

  downloadModal(template: TemplateRef<any>, data) {
    if (data) {
      this.CompanyId = data.CompanyId;
      this.filesname = data.FileName;
      this.file = data.UrlPath;
      this.modalRef = this.modalService.show(template, { class: 'modal-sm modal-dialog-centered' });
    }
  }

  downloadConfirm() {
    this.download();
    this.modalRef.hide();
  }

  download(): any {
    window.open(this.downloadurl + this.filesname);
  }

  decline() {
    this.modalRef.hide();
  }

}
